import { AType, summon } from "@silversea-ssc/functional-support"
import { ALL_CURRENCIES } from "./common"

const currencyRecord: Record<(typeof ALL_CURRENCIES)[number], null> = {
    EUR: null,
    USD: null,
    GBP: null,
    CAD: null,
    AUD: null,
}

export const Currency = summon((F) => F.keysOf(currencyRecord))
export type Currency = AType<typeof Currency>

export const strictType = Currency.strictType
